import {
    Carousel,
    CarouselApi,
    CarouselContent,
    CarouselItem
} from '@/components/common/Carousel';
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTriggerAcc
} from '@/components/common/Tabs';
import { useStore } from '@/hooks/useStore';
import { FORM_TYPE, FormType, ROLE_OWNER } from '@/types/enums';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BasicInformation from './tabs/BasicInformation';
import BasicInformationView from './tabs/BasicInformationView';
import Locations from './tabs/Locations';
import NonRentalDate from './tabs/NonRentalDate';
// import Setting from './tabs/Setting';
import { isRoles } from '@/utils/utils';

const TAB_MIN_WIDTH = 200;

export default observer(function BikeForm({ type }: { type: FormType }) {
    const isOwner = isRoles([...ROLE_OWNER]);

    // const
    const isCreate = type === FORM_TYPE.Create;
    const isView = type === FORM_TYPE.View;

    // hook
    const { t } = useTranslation();

    // const
    const tabsConfig = [
        {
            value: 'basic',
            label: t('words_title.basic_info'),
            Component: isView ? BasicInformationView : BasicInformation
        },
        {
            value: 'locations',
            // label: t('field.location_name'),
            label: '登録拠点',
            Component: Locations
        },
        {
            value: 'non_rental_date',
            label: t('words_title.non_rental_date'),
            Component: NonRentalDate
        }
    ];

    // store
    const {
        uiStore: {
            windowSize: { width }
        },
        bikeStore: { setObservable }
    } = useStore();

    // state
    const [activeTab, setActiveTab] = useState<string>('basic');
    const [api, setApi] = useState<CarouselApi>();
    const [isBasicCompleted, setIsBasicCompleted] = useState<boolean>(false);

    // lifecycle
    useEffect(() => {
        return () => {
            setObservable('bikeDetail', null, { isMergeObject: false });
        };
    }, []);

    // function
    const handleTabChange = (tabValue: string) => {
        setActiveTab(tabValue);
        api?.scrollTo(
            tabsConfig.findIndex(item => item.value === tabValue),
            false
        );
    };

    return (
        <div>
            <Tabs
                value={activeTab}
                onValueChange={handleTabChange}
                className='w-full'
            >
                {width > TAB_MIN_WIDTH * tabsConfig.length ?
                    (
                        <TabsList
                            className={
                                `grid w-full gap-1.5 ${isOwner && !isView ? 'grid-cols-3' : 'grid-cols-4'}`
                            }
                        >
                            {tabsConfig.map(({ value, label }, index) => (
                                <TabsTriggerAcc
                                    key={index}
                                    value={value}
                                    disabled={isCreate && !isBasicCompleted && index > 0}
                                >
                                    {label}
                                </TabsTriggerAcc>
                            ))}
                        </TabsList>
                    ) :
                    (
                        <TabsList className='w-full'>
                            <Carousel
                                opts={{
                                    align: 'start'
                                }}
                                className='w-full'
                                setApi={setApi}
                            >
                                <CarouselContent className='w-full snap-x snap-mandatory ml-0 gap-1.5'>
                                    {tabsConfig.map(({ value, label }, index) => (
                                        // <CarouselItem key={index} className='basis-[60%] point-375:basis-[40%] xsm:basis-[35%] point-600:basis-[28%] pl-0'>
                                        <CarouselItem key={index} className='basis-[180px] pl-0'>
                                            <TabsTriggerAcc
                                                key={index}
                                                value={value}
                                                disabled={isCreate && !isBasicCompleted && index > 0}
                                                className='w-full basis-auto'
                                            // onClick={() => api?.scrollTo(index, false)}
                                            >
                                                {label}
                                            </TabsTriggerAcc>
                                        </CarouselItem>
                                    ))}
                                </CarouselContent>
                            </Carousel>
                        </TabsList>
                    )}

                {tabsConfig.map(({ value, Component }, index) => (
                    <TabsContent key={value} value={value} className='mt-0'>
                        <Component
                            type={type}
                            onComplete={
                                index === 0 ? () => setIsBasicCompleted(true) : undefined
                            }
                            {...((value === 'basic' || value === 'non_rental_date') && {
                                isOwner
                            })}
                        />
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    );
});
